import { Code } from '@/types'
import { t } from '@/lang'
import { showFailToast } from 'vant'
import { closeBrowserPage } from '@/utils/closeBrowserPage'

export function useCode() {
  // const router = useRouter()
  return {
    handleCode: (code: Code, msg: string) => {
      let message = msg
      if (code === Code.EXPIRED) {
        message = t().C4()
      } else if (code === Code.RECEIVED) {
        message = t().C5()
      } else if (code === Code.TOO_FREQUENT) {
        message = t().C6()
      } else if (code === Code.NOT_EXIST) {
        message = t().C2()
      } else if (code === Code.NOT_START) {
        message = t().C3()
      } else if (code === Code.NETWORK_ERROR) {
        message = t().C1()
      }

      showFailToast({
        message: message,
        duration: 3000,
      })
      setTimeout(() => {
        closeBrowserPage()
      }, 3000)
    },
  }
}
